import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { btnPrimary, btnGhost } from "@/components/kit";
import { XTextLink } from "@/components/Buttons";
import { PROJECT_NAME } from "@/config/actra";

export const FinalCTA = () => (
    <section data-testid="final-cta" className="section relative overflow-hidden">
        <div
            className="absolute inset-0"
            style={{ background: "radial-gradient(70% 90% at 50% 100%, rgba(22,119,255,0.22) 0%, transparent 70%)" }}
            aria-hidden="true"
        />
        <div className="absolute inset-0 bg-grid opacity-50" aria-hidden="true" />
        <div className="shell relative py-10 text-center">
            <Reveal>
                <img src="/actra-logo.png" alt="" className="mx-auto h-20 w-20 object-contain" style={{ mixBlendMode: "screen" }} loading="lazy" />
                <h2 className="mt-8 font-display text-[clamp(2.2rem,6vw,4.6rem)] font-bold uppercase leading-[1.0] tracking-tightest">
                    THE ACTION ECONOMY
                    <br />
                    NEEDS <span className="text-[#1677FF]">PROOF.</span>
                </h2>
                <p className="mt-6 font-mono text-xs uppercase tracking-[0.34em] text-mute md:text-sm">
                    {PROJECT_NAME} — VERIFY EVERY ACTION.
                </p>
                <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
                    <Link to="/tasks" data-testid="final-cta-explore" className={btnPrimary}>
                        EXPLORE PROTOCOL <ArrowRight size={14} />
                    </Link>
                    <Link to="/docs" data-testid="final-cta-docs" className={btnGhost}>
                        VIEW DOCS
                    </Link>
                    <XTextLink testid="final-cta-x">FOLLOW ON X</XTextLink>
                </div>
            </Reveal>
        </div>
    </section>
);

export default FinalCTA;
